import { render, staticRenderFns } from "./SurveyStart.vue?vue&type=template&id=52ba705a&scoped=true&"
import script from "./SurveyStart.vue?vue&type=script&lang=js&"
export * from "./SurveyStart.vue?vue&type=script&lang=js&"
import style0 from "./SurveyStart.vue?vue&type=style&index=0&id=52ba705a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ba705a",
  null
  
)

export default component.exports